/** Set on explicit logout so refresh/cookie flows do not silently restore a session. */
const USER_LOGOUT_GATE_KEY = 'ofrontend.userLogoutGate';

export function markUserInitiatedLogout(): void {
  try {
    sessionStorage.setItem(USER_LOGOUT_GATE_KEY, '1');
  } catch {
    /* private mode */
  }
}

export function clearUserInitiatedLogoutGate(): void {
  try {
    sessionStorage.removeItem(USER_LOGOUT_GATE_KEY);
  } catch {
    /* private mode */
  }
}

/** True after logout until the next successful sign-in. */
export function isUserInitiatedLogoutGateActive(): boolean {
  try {
    return sessionStorage.getItem(USER_LOGOUT_GATE_KEY) === '1';
  } catch {
    return false;
  }
}
